export const TABLE_COLOR_SCHEME = {
  BLACK: 'black',
  WHITE: 'white',
};

/** Maximum number of displayed limits in table info, limit selection popup */
export const MAX_DISPLAYED_LIMITS = 4;
